<template>
  <v-container>
    <h1 class="title mb-5">Pepper Sketchy Micro Content</h1>
    <p v-if="selected" class="title">Selected Deck: <span class="blue--text">{{selected}}</span></p>
    <v-btn v-if="selected"  @click="clearDeck" >Clear Selection</v-btn>
    <v-btn color="blue" dark v-if="selected" @click="$router.push({name:'AlgoPrototype', params: {cards: filteredDeck}})">Practice Ordered Deck</v-btn>
    <v-btn color="purple" dark v-if="selected" @click="$router.push({name:'AlgoPrototype', params: {cards: randomize(filteredDeck)}})">Practice Randomized Deck</v-btn>
    <v-switch label="Show Cards" v-if="selected" v-model="showCards"></v-switch>
    <div v-if="!selected">
      <p>Pick a deck from the list below to review. You can use any level of the hierarchy.</p>
      <div hover class="px-3" v-for="(lev_1, lev_1_title) in ds">
        <v-card @click="setDeck(lev_1_title)" hover flat>{{lev_1_title}}</v-card>
        <div hover flat class="px-3" v-for="(lev_2, lev_2_title) in lev_1">
          <v-card @click="setDeck(lev_2_title)" hover flat>{{lev_2_title}}</v-card>
          <div hover flat class="px-3" v-for="(lev_3, lev_3_title) in lev_2">
            <v-card @click="setDeck(lev_3_title)" hover flat>{{lev_3_title}}</v-card>
            <div hover flat class="px-3" v-for="(lev_4, lev_4_title) in lev_3">
              <v-card @click="setDeck(lev_4_title)" hover flat>{{lev_4_title}}</v-card>
            </div>
          </div>

        </div>
      </div>
    </div>



    <div v-if="selected && showCards">
      <v-select label="Pick Deck" :items="decks" v-model="selected">Test</v-select>

      <v-card v-for="(entry, y) in filteredDeck" :key="y">
        <div class="headline blue--text px-5 py-3" v-html="entry.question"></div>
        <div class="headline px-5 py-2" v-html="entry.answer"></div>
        <img class="pa-5 image-size" v-for="(i, z) in getSRC(entry.images)" :key="z" :src="'https://omentum.s3.us-east-1.amazonaws.com/anki_pepper/' + i"/>

      </v-card>
    </div>


    </v-card>
  </v-container>
</template>
<script>
import firebase from 'firebase'
import pepper from '@/anki/pepper.json'
import ds from '@/anki/ds.json'
import _ from 'underscore'
import db from '@/fb'
export default {
  name: 'Anki',
  data() {
    return {
      magic: null,
      cards: pepper,
      selected: null,
      ds: ds,
      showCards: false
    }
  },
  computed: {
    filteredDeck() {
      return this.cards.filter(item => {
        return item.metadata.hierarchy.includes(this.selected)
      })
    },
    decks() {
      let list = []
      this.cards.forEach(card => {
        try {
          list.push(card.metadata.hierarchy[3])
        }
        catch(err) {
          console.log(err)
        }

      })
      return _.sortBy(_.uniq(list))
    }

  },
  mounted() {


  },
  methods: {
    setDeck(value) {
      this.selected = value
    },
    clearDeck() {
      this.selected = null
    },

    makeURLs() {
      // Get a reference to the storage service, which is used to create references in your storage bucket
      var storage = firebase.storage();

      // Create a storage reference from our storage service
      var storageRef = storage.ref();

      // Create a child reference
      var imagesRef = storageRef.child('anki');

      // var specific = imagesRef.child('paste-100712688123907.jpg')
      // specific.getDownloadURL().then(result => {console.log(result)})

      let names = []
      imagesRef.listAll().then(res => {

        let promises = []
        res.items.forEach(item => {
          names.push(item.name)
          promises.push(item.getDownloadURL())
        })
        return Promise.all(promises)

      }).then(result => {
        let final = {}
        names.forEach((name, index) => {
          final[name] = result[index]
        })
        this.magic = JSON.stringify(final)
      })


    },
    getSRC(str){
      var m,
          urls = [],
          rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;

      while ( m = rex.exec( str ) ) {
          urls.push( m[1] );
      }
      return urls

    },
    randomize(cards) {
      return _.shuffle(cards)
    }
  }
}

</script>
<style>
.image-size {
  max-width: 500px;
}

</style>
